export default __webpack_public_path__ + "static/media/匯入.01243e65.svg";